// @ts-ignore
import { isPhone } from 'base/utils/client';

const CDN_ROOT = `https://${process.env.NEXT_PUBLIC_CDN_HOST}/`;

export const site: Record<string, any> = {
    project: 'matrix',
    brand: 'Matrix',
    affiliation: 'matrix-lighting.com',
    domain: 'www.matrix-lighting.com',
    icon: `${CDN_ROOT}asset/width-1024/picture/fde4a2b6f1ff7f1172fb00a1423e58db.png`,
    placeHolderImage: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',//透明图片
    errorImage: `${CDN_ROOT}asset/width-1024/picture/a81665a874f8c375bd58d2dbe3bd4fc0.png`,//透明图片
    cdnRoot: CDN_ROOT,
    seo: {
        image: `${CDN_ROOT}asset/width-1024/picture/fde4a2b6f1ff7f1172fb00a1423e58db.png`,
    },
    gtm: {
        containerId: 'GTM-MXKH8RJ8',
        sdkUrl: 'https://www.googletagmanager.com/gtm.js',
    },
    contact: {
        email: {
            default: 'sales@matrix-lighting.com',
        },
        phone: {
            url: '+19092239485',
            text: '+1 (909)223-9485',
            onlineTime: 'Monday to Friday, 7AM-6PM PST.',
        },
        address: '1575 E Acacia St, Ontario, CA 91761',
    },
    sns: {
        instagram: 'https://www.instagram.com/matrixlighting.official/',
        facebook: 'https://www.facebook.com/MatrixGrowLighting/',
        youtube: 'https://www.youtube.com/@MatrixLighting',
    },
    fonts: {
        dir: CDN_ROOT + 'file-asset/file/e187d0b665c0e77f655f8ca5598544a1/1752652044937/',
        css: 'fonts.css',
        files: [
            'ESDokument-CnBk.woff2',
            'ESDokument-ExBd.woff2',
        ]
    },
    loading: {
        default: 'data:image/png;base64,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',
    },
    useRem: false,

    // 新增配置
    defaultTitle: 'Matrix',
    appLinkRoot: '',
    appDownloadLink: '',
    sp: {
        projectName: 'vivosun',
        collector: 'spc.vivosun.com',
        sdkUrl: 'https://ssc.vivosun.com/3.4.0/vt.js',
        postPath: '/vst/p2',
        stepDetail: false,
        appId: {
            prod: 'vivosun-dtc',
            test: 'vivosun-test',
        },
    },
    ga: {
        trackingId: 'G-QRR3KN14RK',
        sdkUrl: 'https://ssc.vivosun.com/gtag/js',
        transportUrl: 'https://ssc.vivosun.com/sst',
    },
    facebook: {
        pixelId: '451081593338720',
        testAppId: '559840205245660',
        appId: '690291885445775',
    },
    checkout: {
        publicKeySBox: 'pk_sbox_y7m3wl6yo7yps3pny3lo54ujfu4',
        publicKey: 'pk_j4h54hlh2mx24jddcps34ki6sy2',
    },
    google: {
        testAppId: '402621575795-u0d07p0b522hmcgv70g0k41n084qighe.apps.googleusercontent.com',
        appId: '428398099659-tvue8oj3mf68cfd0ogkrt5arjegfntpr.apps.googleusercontent.com'
    },
    klarna: {
        isShowOSM: false,
        testClientId: 'ad1dc01b-e90b-5710-b96f-e14f4f2aeb16',
        clientId: '6e6cedce-037a-5d0b-9841-ba164ded372f'
    },
    iconfont: {
        dir: CDN_ROOT + 'file-asset/file/6557aeac34574155e7c6ec7f42b6a97c/1761202130190/',
        css: 'iconfont.css',
        files: [
            'iconfont.woff2',
        ]
    },
    // registerActivity: {
    //     discount: '10%',
    //     points: 420,
    //     price: 4.2,
    //     couponCode: 'WELCOME'
    // },
    // zenDesk: {
    //     scriptSrc: 'https://static.zdassets.com/ekr/snippet.js?key=7a6b885f-84b7-4fe7-bfa8-8272e7d22f17'
    // },
    theme: 0,
    tagThemeActive: false
};

export default site;
